export const WINDOW: Window | undefined =
  (typeof window === 'object' && window) || undefined;

type BreakpointType = {
  xmobile: number;
  mobile: number;
  tablet: number;
  desktop: number;
  widescreen: number;
  hd: number;
};

export type BreakpointResults = {
  [key in keyof BreakpointType]: boolean;
};

export const defaultBreakpoints: BreakpointType = {
  xmobile: 323,
  mobile: 619,
  tablet: 991,
  desktop: 992,
  widescreen: 1280,
  hd: 1920
};

/**
 * Device Factory helper methods
 */
export class Devices {
  static breakpoints = defaultBreakpoints;

  static withSizes(breakpoints: BreakpointType): Devices {
    this.breakpoints = Object.assign(this.breakpoints, breakpoints);
    return this;
  }

  /**
   * is width xmobile and below
   */
  static isXMobile(): boolean {
    const width = WINDOW?.innerWidth || 1000;
    return width <= this.breakpoints.xmobile;
  }

  /**
   * is width mobile and below. returns true even on xmobile
   */
  static isMobile(): boolean {
    const width = WINDOW?.innerWidth || 1000;
    return width <= this.breakpoints.mobile;
  }

  /**
   * is width above mobile and below desktop
   */
  static isTabletOnly(): boolean {
    const width = WINDOW?.innerWidth || 1000;
    return width <= this.breakpoints.tablet && width > this.breakpoints.mobile;
  }

  /**
   * is width less than tablet? returns true even on mobile and xmobile
   */
  static isTablet(): boolean {
    const width = WINDOW?.innerWidth || 1000;
    return width <= this.breakpoints.tablet;
  }

  /**
   * is width greater than tablet?
   */
  static isDesktop(): boolean {
    const width = WINDOW?.innerWidth || 1000;
    return width >= this.breakpoints.tablet;
  }

  /**
   * is width greater than max-flex of desktop (1280px). i.e the breakpoint after which
   * max-width does not keep growing.
   */
  static isWidescreen(): boolean {
    const width = WINDOW?.innerWidth || 0;
    return width >= this.breakpoints.widescreen;
  }

  /**
   * is width greater than or equal to HD.
   */
  static isHD(): boolean {
    const width = WINDOW?.innerWidth || 0;
    return width >= this.breakpoints.hd;
  }
}
// -------------------------------------------------------------
